// =========================================================
// * Component toolbox with configs, when adding a new component refer to the below
// =========================================================
// * The sample structure of a new component is:
//
// * {
// *    id: "1", This needs to be the current highest id in the toolbox + 1
// *    x: 0, Don't change this
// *    y: 0, Don't change this
// *    width: 14, This is the default width of the control
// *    height: 2, This is the default height of the control
// *    config: {}, This is where any properties that should be saved with the layout are stored, more details below
// *    type: "detail", The two options are "detail" or "visible"
// *    component: Component, This is the imported component file
// *    name: "Component Name", It is vital to the toolbox that when the spaces are removed from this property that it matches the "name" property in the component you've created
// * }
//
// ================= CONFIG PROPERTIES ====================
//
// * Some config properties are designed to pre-populate the filter menu
// * These are the properties that update the required data from diamond and therefore must be used if the control requires any of the following properties
// * If you need to extend functionality for a control, e.g AgentDisplay has a colour for each chosen agentState, you can listen for the emitted values from the control base component, for example:
//
// * <control-base @campaign-selected="yourMethod"></control-base>
//
// * Examples of how to use these auto-populated properties can be found in most controls
//
// ===== CAMPAIGN NAMES ======
//
// * campaignNames: []
//
// * EMIT EVENTS
// * Event names: campaign-selected, campaign-removed
// * Value: campaign name
//
// ====== AGENT STATES =======
//
// * agentStates: []
//
// * EMIT EVENT
// * Event name: state-selected, state-removed
// * Value: state int
//
// ======= QUEUE NAMES =======
//
// * queueNumbers: []
//
// * EMIT EVENT
// * Event name: queue-selected, queue-removed
// * Value: queue number
//
// === Diamond object properties ===
//
// * campaignProperties: []
// * agentProperties: []
// * queueProperties: []
//
// * EMIT EVENT
// * Event name: property-selected, property-removed
// * Value: property name
//

import {
    CampaignPropertyDisplay,
    AvailableAgents,
    Label,
    AgentTable,
    CampaignTable,
    QueueTable,
    TotalAgentsInState,
    AgentDisplay,
    AgentStateChart,
    QueueingCalls,
} from "./components"

var toolbox = [{
    id: "1",
    x: 0,
    y: 0,
    width: 14,
    height: 2,
    config: {
        campaignNames: [],
        showRobots: false,
        showGDMSMonitor: false,
        talkingColor: "#7ade64",
        wrappingColor: "#d68a2d",
        waitingColor: "#cc2549"
    },
    type: "detail",
    component: AvailableAgents,
    name: "Available Agents",
},
{
    id: "2",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    config: {
        campaignNames: [],
        selectedProperty: "Select Property",
        overrideText: "",
        selectedCalculation: { key: "ConnectedCalls", value: "Abandoned/ConnectedCalls+Abandoned" }
    },
    type: "visible",
    component: CampaignPropertyDisplay,
    name: "Campaign Statistic",
},
{
    id: "3",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    config: {
        text: "Default Text",
        backgroundColour: "#ffffff",
        textColour: "#000000"
    },
    type: "visible",
    component: Label,
    name: "Label",
},
{
    id: "4",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    config: {
        campaignNames: [],
        columns: [],
        agentProperties: [],
        pinAgent: false,
        agentStates: [],
        chosenStates: [],
        rows: 10,
    },
    type: "detail",
    component: AgentTable,
    name: "Agent Table",
},
{
    id: "5",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    config: {
        campaignNames: [],
        selectedProperty: {
            name: "Select State",
            value: 0
        },
        overrideText: ""
    },
    type: "visible",
    component: TotalAgentsInState,
    name: "Agents In State",
},
{
    id: "6",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    config: {
        campaignNames: [],
        agentStates: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 15, 16, 17],
        useStateBackground: false,
        inboundColor: '#ffffff',
        chosenStates: [{ "state": 0, "color": "#366131" }, { "state": 1, "color": "#a7c244" }, { "state": 2, "color": "#74E1E2" }, { "state": 3, "color": "#C85C5C" }, { "state": 4, "color": "#7444c2" }, { "state": 5, "color": "#446ec2" }, { "state": 6, "color": "#96DA79" }, { "state": 7, "color": "#D29A50" }, { "state": 9, "color": "#44b7c2" }, { "state": 10, "color": "#44c26c" }, { "state": 11, "color": "#c2448b" }, { "state": 12, "color": "#c2a244" }, { "state": 15, "color": "#8c856d" }, { "state": 16, "color": "#7a8c6d" }, { "state": 17, "color": "#463857" }],
        showRobots: false,
        showGDMSMonitor: false,
        selectedSort: {
            name: "By State then Time",
            value: 4,
        },
        showWrap: false,
        showIcon: true,
        agentSortOrder: [6, 7, 3, 0, 1, 2, 4, 5, 9, 10, 11, 12, 15, 16, 17]
    },
    type: "visible",
    component: AgentDisplay,
    name: "Agents Tile Display",
},
{
    id: "7",
    x: 0,
    y: 0,
    width: 6,
    height: 6,
    config: {
        campaignNames: [],
        agentStates: [],
        stateColours: [],
        showRobots: false,
        showGDMSMonitor: false,
    },
    type: "detail",
    component: AgentStateChart,
    name: "Agent State Chart",
},
{
    id: "8",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    config: {
        campaignNames: [],
        campaignProperties: [],
        columns: [],
        rowHighlight:{
            property: "",
            quantity: "",
            color: ""
        },
        rows: 10,
    },
    type: "detail",
    component: CampaignTable,
    name: "Campaign Table",
},
{
    id: "9",
    x: 0,
    y: 0,
    width: 4,
    height: 8,
    config: {
        split: false,
        flash: false,
        flashColors: {
            first: "#ffffff",
            second: "#ffffff"
        },
        fixedColor: false,
        fixedColors: [],
        queueNumbers: [],
        campaignNames: [],
        sortBy: null,
        statsToDisplay: [
            "CallsInQueue",
            "AbandonedCalls",
            "AbandonRate",
            "OldestCallInQueue",
            "TotalCalls"
        ]
    },
    type: "detail",
    component: QueueingCalls,
    name: "Queueing Calls",
},
{
    id: "10",
    x: 0,
    y: 0,
    width: 8,
    height: 8,
    config: {
        campaignNames: [],
        queueProperties: [],
        columns: [],
        rows: 10,
    },
    type: "detail",
    component: QueueTable,
    name: "Queue Table",
}]

export default toolbox;